import { FC } from 'react';

import SelectStyled, { PropsInput } from './styles';
const Input: FC<PropsInput> = ({ ...props }) => {
  return <SelectStyled {...props} />;
};

export default Input;
